export default __webpack_public_path__ + "static/media/scientists-06.ce726aea.svg";